export default "__VITE_ASSET__BBcngFh0__"